module.exports = __webpack_public_path__ + "images/daea2e51c08093cf233ce6132d4ae1c9.png";